import { render, staticRenderFns } from "./Slideshow.vue?vue&type=template&id=660173f5&"
import script from "./Slideshow.vue?vue&type=script&lang=ts&"
export * from "./Slideshow.vue?vue&type=script&lang=ts&"
import style0 from "./Slideshow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports